import type { ViewerApplicationConnection } from "../../types/viewer";
import type Application from "../../types/application";
import { httpClient } from "./httpClient";

export const fetchApplications = (limit?: number, skip?: number): Promise<ViewerApplicationConnection> => {
    return httpClient.get<ViewerApplicationConnection>("/rest/applications", {
        params: { limit, skip },
    });
};

export const fetchApplicationDetail = async (applicationId: string): Promise<Application> => {
    if (!applicationId) {
        throw new Error("Application ID is required");
    }

    return httpClient.get<Application>(`/rest/applications/${encodeURIComponent(applicationId)}`);
};
